import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'underscore';
import { bindActionCreators } from "redux";
import { message, Modal } from "antd";
import Spinner from '../../Theme/Spinner';
import { Toast, Confirm } from '../../Notification';
import * as tourActions from '../../../redux/actions/tourActions';
import * as dayTypeActions from '../../../redux/actions/dayTypeActions';
import * as mealActions from '../../../redux/actions/mealActions';
import * as liveScheduleActions from '../../../redux/actions/liveScheduleActions';
import * as detailedScheduleActions from '../../../redux/actions/detailedScheduleActions';
import * as resourceActions from '../../../redux/actions/resourceActions';
import * as assignmentActions from '../../../redux/actions/assignmentActions';
import * as authActions from '../../../redux/actions/authActions';
import * as userActions from '../../../redux/actions/userActions';
import blankTour from '../utils/live-schedules/blankTour';
import blankAssignment from '../utils/live-schedules/blankAssignment';
import dayTypes from '../utils/live-schedules/drop-down-tables/dayTypes';
import AuthLogic from '../../../AuthLogic';
import loadItemData from './utils/loadItemData';
import LiveScheduleUpdateFormContainer from './FormContainers';
import CRUD from './utils/CRUD';
import generateNewOptimisticItem from './utils/generateNewOptimisticItems';
import DayTypeRequestsUpdate from '../../DayType/DayTypeRequestsUpdate';
import blankDayTypeRequest from '../../DayType/utils/day-type-requests/blankDayTypeRequest'
import forceTimeInterval from '../../../utils/forceTimeInterval';
import getOffsetTime from '../../../utils/getOffsetTime';

class LiveScheduleUpdate extends Component {
  constructor(props) {
    super(props);
    // this._isMounted = false;  // prevent memory leaks
    this.state = {
      resource: this.props.resource || {id: this.props.itemDetails.group, name: this.props.itemDetails.resourceName}, // { id, name } -- from groupRenderLive
      startDate: this.props.startDate,
      itemDetails: {...this.props.itemDetails},
      confirmDialogue: null,
      showItemContextModal: false,
      loading: false,
      selectedDayTypeRequest: {...blankDayTypeRequest},
    };
  }

  setLoading = (value) => {
    this.setState({
      loading: value
    });
  }

  componentWillUnmount() {
    console.log('Live Schedule Update - UN-MOUNTING...');  // DEBUG
    // this._isMounted = false;  // prevent memory leaks
  }

  componentDidMount = async () => {
    const { contextMenuSelection } = this.props;
    const { user, startDate } = this.props;
    const { resource, itemDetails } = this.state;
    console.log('contextMenuSelection: ', this.props.contextMenuSelection);  // debug
    if (contextMenuSelection === 'Delete Tour' && this.state.confirmDialogue === null) {
      this.handleItemDelete('tour');
    }
    if (contextMenuSelection === 'Add Tour') {
      const { tourStartTime, tourEndTime } = blankTour(startDate);
      await this.getBranch();
      this.generateTourDuration(tourStartTime, tourEndTime);
      this.showModal();
    }
    if (contextMenuSelection === 'Delete Assignment' && this.state.confirmDialogue === null) {
      this.handleItemDelete('assignment');
    }
    if (contextMenuSelection === 'Add Assignment') {
      const { assignmentStartTime, assignmentEndTime } = blankAssignment(startDate);
      this.generateItemDuration('assignment', assignmentStartTime, assignmentEndTime);
      this.showModal();
      const userId = this.props.user.login.id;
      await this.getBranch();
      await this.props.actions.fetchRelatedBranches(userId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getRelatedBranches failed\n" + JSON.stringify(error));
          }
        });
      itemDetails.timeZoneId = this.props.branch.userTimeZoneId,
      itemDetails.executingBranchId = this.props.relatedBranches.data[0].id;
      itemDetails.priceMethodId = user.securityLevels.defaultPriceMethod;
      itemDetails.status = 10; // default is standby = 10
      this.setState({
        itemDetails
      });
      const parameters = {
        state: this.state,
        relevantJobs: this.props.relevantJobs.data, // undefined here
        relevantJobsForCostObject: this.props.relevantJobsForCostObject.data, // undefined here
        relatedBranches: this.props.relatedBranches.data,
        groupsByBranchAndResource: this.props.groupsByBranchAndResource.data, // undefined here
        servicesByDate: this.props.servicesByDate.data, // undefined here
        activityTypes: this.props.activityTypes.data, // undefined here
        updateState: this.updateState
      };
      /* this._isMounted = true  && */ await loadItemData.addAssignment(parameters);
    }

    if (contextMenuSelection === "Change Day Type") {
      const { resource, itemDetails } = this.state;
      this.showModal();
      // either get resource from LiveScheduleGroupContext (right-clicking on group) or LiveScheduleView (right-clicking on item)
      const resourceId = !itemDetails.id ? resource.id : itemDetails.group;
      const date = !itemDetails.id ? moment(startDate).format('YYYY-MM-DD') : moment(itemDetails.start_time).format('YYYY-MM-DD');
      const isApprover = AuthLogic.isApprover(this.props.user);
      await this.props.actions.fetchResourceDayTypeByDate(resourceId, date)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getDayTypesAll failed\n" + JSON.stringify(error));
          }
        });

      await this.props.actions.fetchDayTypesAll(isApprover, resourceId, date)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getDayTypesAll failed\n" + JSON.stringify(error));
          }
        });

      const parameters = {
        startDate: this.props.startDate,
        state: this.state,
        date,
        isApprover,
        resourceDayType: this.props.resourceDayType.data[0] || {},
        dayTypesAll: this.props.dayTypesAll.dayTypes,
        allowTourDayTypes: dayTypes,
        updateState: this.updateState
      };
      /* this._isMounted = true && */ await loadItemData.changeDayType(parameters);
    }
    if (contextMenuSelection === "Edit Tour") {
      const { resource, itemDetails } = this.state;
      this.showModal();
      this.setLoading(true);
      const startDate = itemDetails.start_time.format('YYYYMMDD');
      const endDate = itemDetails.end_time.format('YYYYMMDD');
      const userId = this.props.user.login.id;
      const tourId = itemDetails.id.split('-')[0];
      const { rdtId } = itemDetails;
      await this.getDetailedSchedules(startDate, endDate, resource.id, userId);
      await this.getBranch();

      // USED IN EVERY TAB
      await this.props.actions.fetchJobElementsByTour(tourId).catch(error => {
        alert("Loading jobElementsByTour failed\n" + JSON.stringify(error));
        console.log(error);
      });

      // MEALS TAB
      await this.props.actions.fetchTourMeals(tourId).catch(error => {
        alert("Loading tourMeals failed\n" + JSON.stringify(error));
        console.log(error);
      });
      let meal = this.props.liveSchedule.liveSchedule.find((elem) => elem.rId == resource.id).dayTypes[rdtId].tour.meal;
      let mealId;
      if (meal) {
        mealId = meal.mealId;
        await this.props.actions.fetchMeal({ mealId }).catch(error => {
          alert("Loading meal failed\n" + JSON.stringify(error));
          console.log(error);
        })
      }

      // PAY TRANSACTIONS TAB
      await this.props.actions.fetchTourPayTransactions(tourId).catch(error => {
        alert("Loading tourPayTransactions failed\n" + JSON.stringify(error));
        console.log(error);
      });
      let tourPayTransaction = this.props.liveSchedule.liveSchedule.find((elem) => elem.rId == resource.id).dayTypes[rdtId].tour.tourPayTransactions[0];
      let tourPayTransactionId;
      if (tourPayTransaction) {
        tourPayTransactionId = parseInt(tourPayTransaction.tourPayTransactionId);
        await this.props.actions.fetchTourPayTransaction(tourPayTransactionId).catch(error => {
          alert("Loading tourPayTransaction failed\n" + JSON.stringify(error));
          console.log(error);
        })
      }
      // pay transactions dropdowns
      await this.props.actions.fetchPayTransactionsByTour(tourId).catch(error => {
        alert("Loading payTransactionsByTour failed\n" + JSON.stringify(error));
        console.log(error);
      });

      // INDICATORS TAB
      await this.props.actions.fetchTourIndicators(tourId).catch(error => {
        alert("Loading tourIndicators failed\n" + JSON.stringify(error));
        console.log(error);
      });
      let tourIndicator = this.props.liveSchedule.liveSchedule.find((elem) => elem.rId == resource.id).dayTypes[rdtId].tour.tourIndicators[0];
      let tourIndicatorId;
      if (tourIndicator) {
        tourIndicatorId = parseInt(tourIndicator.tourIndicatorId);
        await this.props.actions.fetchTourIndicator(tourIndicatorId).catch(error => {
          alert("Loading tourIndicator failed\n" + JSON.stringify(error));
          console.log(error);
        })
      }
      // indicators dropdowns
      await this.props.actions.fetchIndicatorsByTour(tourId).catch(error => {
        alert("Loading indicatorsByTour failed\n" + JSON.stringify(error));
        console.log(error);
      })


      // ACTIVITY FLAG TAB
      await this.props.actions.fetchTourActivityFlags(tourId).catch(error => {
        alert("Loading tourActivityFlags failed\n" + JSON.stringify(error));
        console.log(error);
      });
      let tourActivityFlag = this.props.tourActivityFlags.data ? this.props.tourActivityFlags.data[0] : null;
      let tourActivityFlagId;
      if (tourActivityFlag) {
        tourActivityFlagId = parseInt(tourActivityFlag.id);
        await this.props.actions.fetchTourActivityFlag(tourActivityFlagId).catch(error => {
          alert("Loading tourActivityFlag failed\n" + JSON.stringify(error));
          console.log(error);
        });
      }
      // activity flag dropdowns
      await this.props.actions.fetchActivityFlagByTour(tourId).catch(error => {
        alert("Loading activityFlagByTour failed\n" + JSON.stringify(error));
        console.log(error);
      })

      const parameters = {
        state: this.state,
        userId: this.props.user.login.id,
        detailedSchedule: this.props.detailedSchedule.detailedSchedules[0],
        allowTourDayTypes: dayTypes,
        liveSchedule: this.props.liveSchedule.liveSchedule,
        generateTourDuration: this.generateTourDuration,
        updateState: this.updateState,
        // multiple tabs
        jobElementsByTour: this.props.jobElementsByTour,
        generateItemDuration: this.generateItemDuration,
        // meals tab
        tourMeals: this.props.tourMeals,
        meal: meal ? this.props.meal : null,
        // pay transactions tab
        tourPayTransactions: this.props.tourPayTransactions,
        tourPayTransaction: tourPayTransaction ? this.props.tourPayTransaction : null,
        payTransactionsByTour: this.props.payTransactionsByTour,
        // indicators tab
        tourIndicators: this.props.tourIndicators,
        tourIndicator: tourIndicator ? this.props.tourIndicator : null,
        // indicatorById: tourIndicator ? this.props.indicatorById: null,
        indicatorsByTour: this.props.indicatorsByTour,
        // activity flags tab
        tourActivityFlags: this.props.tourActivityFlags,
        tourActivityFlag: tourActivityFlag ? this.props.tourActivityFlag : null,
        activityFlagByTour: this.props.activityFlagByTour,

      };
      /* this._isMounted = true && */ await loadItemData.editTour(parameters);
    }

    if (contextMenuSelection === "Edit Assignment") {
      const { resource, itemDetails } = this.state;
      this.showModal();
      this.setLoading(true);
      const userId = this.props.user.login.id;
      const jobElementId = itemDetails.id;
      const { jobId } = itemDetails;
      await this.getBranch();
      await this.props.actions.fetchJobElement(jobElementId) // don't need await here, hurts perf
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getJobElementId failed\n" + JSON.stringify(error));
          }
        });
      this.props.actions.fetchJobElementsWithDetails(jobId) // don't need await here, hurts perf
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getJobElementsWithDetails failed\n" + JSON.stringify(error));
          }
        });
      const { serviceId } = await this.props.jobElement.data[0];
      await this.props.actions.fetchService(serviceId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getService failed\n" + JSON.stringify(error));
          }
        });
      await this.props.actions.fetchJob(jobId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getJob failed\n" + JSON.stringify(error));
          }
        });
      const { costObjectId, costObjectTypeId, updatingUserId } = await this.props.job.data[0];
      await this.props.actions.fetchCostObject(costObjectId, costObjectTypeId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getCostObject failed\n" + JSON.stringify(error));
          }
        });
      await this.props.actions.fetchUpdatingUser(updatingUserId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getUpdatingUser failed\n" + JSON.stringify(error));
          }
        });

      // put all redux objects into loadItemData module + into state
      // in order to be able to transfer to form
      const parameters = {
        state: this.state,
        userId: this.props.user.login.id,
        updatingUser: await this.props.updatingUser.data[0],
        job: await this.props.job.data[0],
        jobElement: await this.props.jobElement.data[0],
        jobElementsWithDetails: await this.props.jobElementsWithDetails.data.results,
        costObject: await this.props.costObject.data[0],
        groupsByBranchInCompany: this.props.groupsByBranchInCompany.data, // undefined here
        service: await this.props.service.data[0],
        assignmentServicesByGroup: this.props.assignmentServicesByGroup.data, // undefined here
        activityTypes: this.props.activityTypes.data, // undefined here
        generateItemDuration: this.generateItemDuration,
        updateState: this.updateState
      };
      await loadItemData.editAssignment(parameters);
    }

    if (contextMenuSelection === "Add Days Off Request") { // <- James
      const { resource, itemDetails } = this.state;
      this.showModal();
      // either get resource from LiveScheduleGroupContext (right-clicking on group) or LiveScheduleView (right-clicking on item)
      const resourceId = !itemDetails.id ? resource.id : itemDetails.group;
      const date = !itemDetails.id ? moment(startDate).format('YYYY-MM-DD') : moment(itemDetails.start_time).format('YYYY-MM-DD');
      const isApprover = AuthLogic.isApprover(this.props.user);

      await this.props.actions.fetchDayTypesAll(isApprover, resourceId, date)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getDayTypesAll failed\n" + JSON.stringify(error));
          }
        });

      const parameters = {
        startDate: this.props.startDate,
        state: this.state,
        date,
        isApprover,
        resourceDayType: this.props.resourceDayType.data[0] || {},
        dayTypesAll: this.props.dayTypesAll.dayTypes,
        allowTourDayTypes: dayTypes,
        updateState: this.updateState
      };
      /* this._isMounted = true && */ await loadItemData.addDayOffRequest(parameters);
      console.log();
    }

  } // end componentDidMount

  updateState = (newState) => {
    for (let [key, value] of Object.entries(newState)) {
      this.setState({
        [key]: value
      });
    }
  }

  handleItemDelete = (item) => {
    // if or swtich statements to check what itemType is being deleted
    const { resourceName, start_time } = this.props.itemDetails; // itemDetails === selectedItem from liveScheduleView
    if (item === 'tour') {
      let date = moment(start_time).format('M/D/YYYY (ddd)');
      if (this.props.itemDetails.itemType === 'tour') { // this if statement seems redundant
        let text = {
          title: `You are deleting a tour of ${resourceName} on ${date}. Continue?`
        };
        Confirm('deleteTour', text, this.handleConfirmDialogue);
      }
    }
    if (item === 'dayType') {
      let date = moment(this.state.itemDetails.date).format('M/D/YYYY (ddd)')
      let text = {
        title: `You are deleting a day type of ${resourceName} on ${date}. Continue?`
      };
      Confirm('deleteDayType', text, this.handleConfirmDialogue);
    }
    if (item === 'assignment') {
      let date = moment(start_time).format('M/D/YYYY (ddd)');
      let text = {
        title: `You are deleting an assignment of ${resourceName} on ${date}. Continue?`
      };
      Confirm('deleteAssignment', text, this.handleConfirmDialogue);
    }
    if (item === 'job') {
      let text = {
        title: `Are you sure?`
      };
      Confirm('deleteJob', text, this.handleConfirmDialogue);
    }
    if (item === 'meal') {
      let text = {
        title: `Are you sure?`
      };
      Confirm('deleteMeal', text, this.handleConfirmDialogue);
    }
    if (item === 'tourPayTransaction') {
      let text = {
        title: `Are you sure you want to delete this Pay Transactoion?`
      };
      Confirm('deleteTourPayTransaction', text, this.handleConfirmDialogue);
    }
    if (item === 'tourIndicator') {
      let text = {
        title: `Are you sure you want to delete this Indicator?`
      };
      Confirm('deleteTourIndicator', text, this.handleConfirmDialogue);
    }
    if (item === 'tourActivityFlag') {
      let text = {
        title: `Are you sure you want to delete this Activity Flag?`
      };
      Confirm('deleteTourActivityFlag', text, this.handleConfirmDialogue);
    }
  }

  handleConfirmDialogue = (key, value) => {
    let confirmDialogue = {}
    const { itemDetails } = this.state;
    const { startDate } = this.props;
    if (key === 'longTourStartEnd') {
      confirmDialogue.longTourStartEnd = value; // record dialogue response
      if (value === false) {
        // reset all values
        itemDetails.tourStartTime = blankTour(startDate).tourStartTime;
        itemDetails.tourEndTime = blankTour(startDate).tourEndTime;
        itemDetails.mealStartTime = blankTour(startDate).mealStartTime;
        delete itemDetails.tourDurationDays;
        itemDetails.tourDuration = moment(this.formatDuration(8), 'h:mm');
      }
    }
    if (key === 'longAssignmentStartEnd') {
      confirmDialogue.longAssignmentStartEnd = value; // record dialogue response
      if (value === false) {
        // reset all values
        itemDetails.assignmentStartTime = blankAssignment(startDate).assignmentStartTime;
        itemDetails.assignmentEndTime = blankAssignment(startDate).assignmentEndTime;
        delete itemDetails.assignmentDurationDays;
        itemDetails.assignmentDuration = moment(this.formatDuration(8), 'h:mm');
      }
    }
    if (key === 'longTourDuration') {
      confirmDialogue.longTourDuration = value; // record dialogue response
      if (value === false) {
        // reset only duration value
        itemDetails.tourDuration = moment(this.formatDuration(8), 'h:mm');
      }
    }
    if (key === 'longAssignmentDuration') {
      confirmDialogue.longAssignmentDuration = value; // record dialogue response
      if (value === false && itemDetails.assignmentStartTime) {
        // reset only duration value
        itemDetails.assignmentDuration = moment(this.formatDuration(8), 'h:mm');
      }
    }
    if (key === 'deleteTour') {
      confirmDialogue.deleteTour = value;
      if (value === true) {
        // delete tour
        this.deleteTour()
      } else {
        this.props.updateSelectedItem({});
        this.props.closeLiveScheduleUpdate(this.state);
      }
    }

    if (key === 'deleteDayType') {
      confirmDialogue.deleteDayType = value;
      if (value === true) {
        // delete dayType
        this.deleteDayType()
      } else {
        // do nothing
      }
    }

    if (key === 'deleteAssignment') {
      confirmDialogue.deleteAssignment = value;
      if (value === true) {
        // delete assignment
        this.deleteAssignment()
      } else {
        this.props.updateSelectedItem({});
        this.props.closeLiveScheduleUpdate(this.state);
      }
    }

    if (key === 'deleteEmptyJob') {
      confirmDialogue.deleteEmptyJob = value;
      if (value === true) {
        // deleteAssignment method will read confirmDialogue.deleteEmptyJob value
        // and delete both job and job element
      } else {
        // only delete the job element and leave empty job
        this.setState({
          deleteEmptyJobLoading: false,
        });
        // only un-mount component if delete job element has completed
        if (!this.state.deleteJobElementLoading) {
           // still need to refresh to clear last deleted assignment from screen
           // don't need refresh logic here bc if statement already checks if deleting jobElement is in progress
          window.location.reload();
          // this.props.updateSelectedItem({}); // not sure what this does w/ optimistic rendering now off
          // this.props.closeLiveScheduleUpdate(this.state);
        }
      }
    }

    if (key === 'deleteJob') {
      confirmDialogue.deleteJob = value;
      if (value === true) {
        this.deleteJob()
      } else {
        // do nothing
      }
    }

    if (key === 'deleteMeal') {
      confirmDialogue.deleteMeal = value;
      if (value === true) {
        this.deleteMeal()
      } else {
        // do nothing
      }
    }

    if (key === 'deleteTourPayTransaction') {
      confirmDialogue.deleteTourPayTransaction = value;
      if (value === true) {
        this.deleteTourPayTransaction()
      } else {
        // do nothing
      }
    }

    if (key === 'deleteTourIndicator') {
      confirmDialogue.deleteTourIndicator = value;
      if (value === true) {
        this.deleteTourIndicator()
      } else {
        // do nothing
      }
    }

    if (key === 'deleteTourActivityFlag') {
      confirmDialogue.deleteTourActivityFlag = value;
      if (value === true) {
        this.deleteTourActivityFlag()
      } else {
        // do nothing
      }
    }


    this.setState({
      itemDetails,
      confirmDialogue
    });
  }

  finalFormValidation = () => {
    const { contextMenuSelection } = this.props;
    const { itemDetails } = this.state;
    const { itemType } = itemDetails;
    if (contextMenuSelection === 'Add Tour') {
      const { tourStartTime, tourEndTime, mealStartTime, mealEndTime } = itemDetails;
      if (!tourStartTime || !tourEndTime) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Tour must have start and end time');
        return false;
      }
      if (mealStartTime && mealEndTime) {
        if (!moment(mealStartTime).isBetween(tourStartTime, tourEndTime, null, '()')
          || !moment(mealEndTime).isBetween(tourStartTime, tourEndTime, null, '()')
        ) {
          message.config({
            top: 150,
            duration: 5,
            maxCount: 5,
          });
          message.error('Meal times are outside of tour times');
          return false;
        }
      }
      if ((mealStartTime && !mealEndTime)
        || (!mealStartTime && mealEndTime)) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Meal must have start and end time');
        return false;
      }
      if (moment(mealStartTime).isAfter(mealEndTime)) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Meal cannot begin after meal end time!');
        return false;
      }
    }
    if (contextMenuSelection === 'Edit Tour'
    && itemType === 'tour'
    ) {
      const { tourStartTime, tourEndTime } = this.state.itemDetails;
      if (!tourStartTime || !tourEndTime) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Tour must have start and end time');
        return false;
      }
    }
    if (contextMenuSelection === 'Edit Tour'
    && itemType === 'tourActivityFlag'
    ) {
      const { tourActivityFlagStartTime, tourActivityFlagDuration, tourActivityFlagEndTime,
        activityFlagId, tourStartTime, tourEndTime } = itemDetails;
      if (!tourActivityFlagStartTime || !tourActivityFlagDuration) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Activity Flag must have start time and duration.');
        return false;
      }
      if (!activityFlagId) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select an Activity Flag.');
        return false;
      }
      if (tourActivityFlagStartTime.isBefore(tourStartTime)
      || tourActivityFlagEndTime.isAfter(tourEndTime)
      ) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Activity Flag cannot be outside of tour time.');
        return false;
      }
    }

    if (contextMenuSelection === 'Edit Tour'
    && itemType === 'meal'
    ) {
      const { mealStartTime, mealDuration, mealEndTime, tourStartTime, tourEndTime } = itemDetails;
      if (!mealStartTime || !mealDuration) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Meal must have start time and duration.');
        return false;
      }
      if (mealStartTime.isBefore(tourStartTime) || mealEndTime.isAfter(tourEndTime)) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Meal must be within tour time.');
        return false;
      }
    }
    if (contextMenuSelection === 'Edit Tour'
    && itemType === 'tourIndicator'
    ) {
      const { indicatorId, codeId } = itemDetails;
      if (!indicatorId || !codeId) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Must choose indicator and code.');
        return false;
      }
    }
    if (contextMenuSelection === 'Edit Tour'
    && itemType === 'tourPayTransaction'
    ) {
      const { payTransactionId, units, cost } = itemDetails;
      if (!payTransactionId || !units || !cost) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Must enter Pay Transaction, Units and Cost.');
        return false;
      }
    }

    if (contextMenuSelection === 'Add Assignment') {
      const { assignmentStartTime, assignmentEndTime, jobId, jobTitle,
        serviceId, activityType, costObject } = this.state.itemDetails;
      if (!assignmentStartTime || !assignmentEndTime) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please enter a start and end time.');
        return false;
      }
      if ((!jobId || jobId === 'null') && !jobTitle) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a request or enter the title for a new request.');
        return false;
      }
      if (!serviceId || serviceId === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a service.');
        return false;
      }

      if (!serviceId || serviceId === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a service.');
        return false;
      }

      if (!activityType || activityType === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a valid activity type.');
        return false;
      }

      if (!costObject) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a cost object.');
        return false;
      }
    }

    if (contextMenuSelection === 'Edit Assignment') {
      const { assignmentStartTime, assignmentEndTime,
        serviceId, activityType, costObject } = this.state.itemDetails;
      if (!assignmentStartTime || !assignmentEndTime) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please enter a start and end time.');
        return false;
      }

      if (!serviceId || serviceId === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a service.');
        return false;
      }

      if (!serviceId || serviceId === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a service.');
        return false;
      }

      if (!activityType || activityType === 'null') {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a valid activity type.');
        return false;
      }

      if (!costObject) {
        message.config({
          top: 150,
          duration: 5,
          maxCount: 5,
        });
        message.error('Please select a cost object.');
        return false;
      }

      // Edit Job / Request
      if (itemDetails.itemType === 'job') {
        let { jobBaseDate } = itemDetails;
        const { job } = this.state;

        // necessary since all times are converted to moment objects for comparison below (isBefore/isAfter)
        let timeZoneOffset = getOffsetTime(moment(job.startRequest)._d);
        jobBaseDate = jobBaseDate.add(timeZoneOffset, 'minutes').startOf('day');
        let jobStartTime = moment(job.startRequest).clone().add(timeZoneOffset, 'minutes');
        let jobEndTime = moment(job.endRequest).clone().add(timeZoneOffset, 'minutes');

        if (jobBaseDate.isBefore(jobStartTime, 'day')
        || jobBaseDate.isAfter(jobEndTime, 'day')
        ) {
          message.config({
            top: 150,
            duration: 5,
            maxCount: 5,
          });
          message.error('The date must be between start date and end date of request.');
          return false;
        }
      }
    }

    return true;
  }

  getBranch = async () => {
    const userId = this.props.user.login.id;
    const { itemDetails } = this.state;
    await this.props.actions.fetchBranch(userId)
    .catch(error => {
      if (!_.isEmpty(error)) {
        alert("Loading getBranch failed\n" + JSON.stringify(error));
      }
    });
    itemDetails.timeZoneId = this.props.branch.userTimeZoneId;
    this.setState({
      itemDetails
    });
  }

  getDetailedSchedules = async (startDate, endDate, resourceId, userId) => {
    await this.props.actions.fetchDetailedSchedules(startDate, endDate, resourceId, userId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getDetailedSchedule failed\n" + JSON.stringify(error));
          console.log(error);
        }
      });
  }

  handleDayTypeDateChange = async (newDate) => {
    this.setState({
      loading: true
    });
    // re-run APIs w/ new date
    console.log('newDate:', newDate);  // debug
    const { isApprover } = this.state;
    const resourceId = this.state.resource.id;
    const date = moment(newDate).format('YYYY-MM-DD');

    await this.props.actions.fetchResourceDayTypeByDate(resourceId, date)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getDayTypesAll failed\n" + JSON.stringify(error));
          console.log(error);
        }
      });

    await this.props.actions.fetchDayTypesAll(isApprover, resourceId, date)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getDayTypesAll failed\n" + JSON.stringify(error));
          console.log(error);
        }
      });
    // update itemDetails w/ newDate and data from the resourceDayType for that newDate
    const { itemDetails } = this.state;
    const resourceDayType = await this.props.resourceDayType.data[0] || {};
    itemDetails.date = newDate;
    itemDetails.resourceDayType = resourceDayType;
    itemDetails.dayTypeId = resourceDayType.dayTypeId;
    itemDetails.dayTypeComment = resourceDayType.comment || " ";
    itemDetails.myDayTypeComment = resourceDayType.myComment || " ";

    this.setState({
      itemDetails,
      loading: false
    });
  }

  generateTourDuration = async (startTime, endTime) => {
    // tour duration is not an input field for any SP, tracking just for display on form
    const { itemDetails } = this.state;
    let tourDuration;
    if (startTime && endTime && startTime.isBefore(endTime)) {
      tourDuration = moment.duration(endTime.diff(startTime)).asHours();
      if (tourDuration >= 24) { // multi-day tours
        const days = Math.floor(tourDuration / 24);
        const hours = tourDuration % 24;
        itemDetails.tourDurationDays = { days, hours }; // create new field for multi-day scenarios
        itemDetails.tourDuration = moment(this.formatDuration(hours), 'h:mm');
      } else { // tours less than a day
        delete itemDetails.tourDurationDays;
        itemDetails.tourDuration = moment(this.formatDuration(tourDuration), 'h:mm');
      }
    } else { // start and or end time is invalid
      tourDuration = null;
    }
    if (tourDuration > 18) {
      let text = {
        title: "Tour's duration exceeds 18 hours. Do you wish to continue?"
      };
      Confirm('longTourStartEnd', text, this.handleConfirmDialogue);
    }
    // for all scenarios: update state
    this.setState({
      itemDetails
    });
  }

  generateItemDuration = async (itemType, startTime, endTime) => {
    // item duration is not an input field for any SP, tracking just for display on form
    const { itemDetails } = this.state;
    let itemDuration;
    if (startTime && endTime && startTime.isBefore(endTime)) {
      itemDuration = moment.duration(endTime.diff(startTime)).asHours();
      if (itemDuration >= 24) { // multi-day item
        const days = Math.floor(itemDuration / 24);
        const hours = itemDuration % 24;
        itemDetails[`${itemType}DurationDays`] = { days, hours }; // create new field for multi-day scenarios
        itemDetails[`${itemType}Duration`] = moment(this.formatDuration(hours), 'h:mm');
      } else { // item less than a day
        delete itemDetails[`${itemType}DurationDays`];
        itemDetails[`${itemType}Duration`] = moment(this.formatDuration(itemDuration), 'h:mm');
      }
    } else { // start and or end time is invalid
      itemDuration = null;
    }
    if (itemDuration > 18) {
      let text = {
        title: `${itemType}'s duration exceeds 18 hours. Do you wish to continue?`
      };
      Confirm('longTourStartEnd', text, this.handleConfirmDialogue);
    }
    // for all scenarios: update state
    this.setState({
      itemDetails
    });
  }

  formatDuration = (hours) => {
    if (!hours) {
      return null
    }
    const h = Math.floor(hours);
    const mm =  ((hours - Math.floor(hours)) * 60).toFixed(0);
    if (mm >= 10) {
      return `${h}:${mm}`;
    } else {
      return `${h}:0${mm}`;
    }
  }

  handleTourDurationChange = (newDuration) => {
    if (!newDuration) {
      return null;
    }
    newDuration = forceTimeInterval(newDuration);
    if (newDuration.format('HH') > 18) {
      let text = {
        title: "Tour's duration exceeds 18 hours. Do you wish to continue?"
      };
      Confirm('longTourDuration', text, this.handleConfirmDialogue);
    }
    // update itemDetails.tourDuration in state
    const { itemDetails } = this.state;
    itemDetails.tourDuration = newDuration;
    this.setState({
      itemDetails
    }, () => {  // update itemDetails.tourEndtime in state
      const { itemDetails } = this.state;
      // convert duration to minutes
      const newDurationInHours =  moment.duration(this.state.itemDetails.tourDuration.diff(moment().startOf('day'))).asHours();
      // add new duration hours to startTime to get updated endTime
      const tourStartTime = this.state.itemDetails.tourStartTime.clone();
      let newTourEndTime = tourStartTime.add(newDurationInHours, 'hours');
      if (itemDetails.tourDurationDays) { // multi-day scenarios
        const { days } = itemDetails.tourDurationDays;
        newTourEndTime.add(days, 'days');
      }
      // update endTime
      itemDetails.tourEndTime = newTourEndTime;
      this.setState({
        itemDetails
      });
    });
  }

  handleItemDurationChange = (newDuration) => {
    const { itemType } = this.state.itemDetails;
    if (!newDuration) {
      return null;
    }
    newDuration = forceTimeInterval(newDuration);
    if (newDuration.format('HH') > 18) {
      let text = {
        title: `${itemType}'s duration exceeds 18 hours. Do you wish to continue?`
      };
      let capitalizedItemType = itemType.charAt(0).toUpperCase() + itemType.slice(1);
      Confirm(`long${capitalizedItemType}Duration`, text, this.handleConfirmDialogue);
    }
    // update itemDetails[`${itemType}Duration`] in state
    const { itemDetails } = this.state;
    itemDetails[`${itemType}Duration`] = newDuration;
    this.setState({
      itemDetails
    }, () => {  // update itemDetails[`${itemType}EndTime`] in state
      const { itemDetails } = this.state;
      // convert duration to minutes
      const newDurationInHours =  moment.duration(this.state.itemDetails[`${itemType}Duration`].diff(moment().startOf('day'))).asHours();
      // if no startTime, keep duration as null
      if (!this.state.itemDetails[`${itemType}StartTime`]) {
        itemDetails[`${itemType}Duration`] = null;
        return null;
      }
      // add new duration hours to startTime to get updated endTime
      const itemStartTime = this.state.itemDetails[`${itemType}StartTime`].clone();
      let newItemEndTime = itemStartTime.add(newDurationInHours, 'hours');
      if (itemDetails[`${itemType}DurationDays`]) { // multi-day scenarios
        const { days } = itemDetails[`${itemType}DurationDays`];
        newItemEndTime.add(days, 'days');
      }
      // update endTime
      itemDetails[`${itemType}EndTime`] = forceTimeInterval(newItemEndTime);
      this.setState({
        itemDetails
      });
    });
  }

  handleTourStartTimeChange = (newStartTime) => {
    newStartTime = forceTimeInterval(newStartTime);
    const { itemDetails } = this.state;
    // update tourStartTime
    itemDetails.tourStartTime = newStartTime;
    // update tourEndTime
    const tourEndTime = newStartTime ? newStartTime.clone() : null;
    if (tourEndTime) {
      tourEndTime.add(8, 'hours');
    }
    itemDetails.tourEndTime = tourEndTime;
    this.generateTourDuration(newStartTime, tourEndTime);
    this.setState({
      itemDetails
    });
  }

  handleItemStartTimeChange = (newStartTime) => {
    newStartTime = forceTimeInterval(newStartTime);
    const { itemDetails } = this.state;
    const { itemType } = itemDetails;
    // update item StartTime
    itemDetails[`${itemType}StartTime`] = newStartTime;
    // update item EndTime
    const itemEndTime = newStartTime ? newStartTime.clone() : null;
    if (itemEndTime) {
      itemEndTime.add(1, 'hours');
    }
    itemDetails[`${itemType}EndTime`] = itemEndTime;
    this.generateItemDuration(`${itemType}`, newStartTime, itemEndTime);
    this.setState({
      itemDetails
    });
  }

  handleTourEndTimeChange = (newEndTime) => {
    newEndTime = forceTimeInterval(newEndTime);
    // update tourEndTime
    const { itemDetails } = this.state;
    const { tourStartTime } = itemDetails;
    itemDetails.tourEndTime = newEndTime;
    this.generateTourDuration(tourStartTime, newEndTime);
    this.setState({
      itemDetails
    });
  }

  handleItemEndTimeChange = (newEndTime) => {
    newEndTime = forceTimeInterval(newEndTime);
    // update itemEndTime
    const { itemDetails } = this.state;
    const { itemType } = itemDetails;
    itemDetails[`${itemType}EndTime`] = newEndTime;
    this.generateItemDuration(`${itemType}`, itemDetails[`${itemType}StartTime`], newEndTime);
    this.setState({
      itemDetails
    });
  }

  handleMealStartTimeChange = (newMealStartTime) => {
    const { itemDetails } = this.state;
    if (!newMealStartTime) {
      // no meal
      itemDetails.mealStartTime = null;
      itemDetails.mealEndTime = null;
      itemDetails.mealDuration = null;
    } else {
      newMealStartTime = forceTimeInterval(newMealStartTime);
      itemDetails.mealStartTime = newMealStartTime;
      this.generateItemDuration(`meal`, itemDetails.mealStartTime, itemDetails.mealEndTime);
    }
    this.setState({
      itemDetails
    });
  }

  handleMealEndTimeChange = (newMealEndTime) => {
    newMealEndTime = forceTimeInterval(newMealEndTime);
    const { itemDetails } = this.state;
    if (newMealEndTime) {
      itemDetails.mealEndTime = newMealEndTime;
    }
    this.setState({
      itemDetails
    });
  }

  handleOmnibusFieldChange = (e) => {
    if (!e) {
      return null;
    }
    const { itemDetails } = this.state;
    let field;
    let value;
    // select dropdown
    if (typeof e === 'string') {
      field = e.split('-')[0];
      value = e.split('-')[1];
      // when value is a number, convert string to number
      if (!isNaN(value)) {
        value = parseInt(value);
      }
    }
    if (e._isAMomentObject) {
      // base date on edit job
      itemDetails.jobBaseDate = e;
    }
    else if (typeof e === 'object') {
      field = e.target.name;
      // checkbox
      if (e.target.type === 'checkbox') {
        value = e.target.checked;
      } else { // text input
        value = e.target.value;
      }
    }
    // update state
    itemDetails[`${field}`] = value;
    this.setState({
      itemDetails
    });
  }

  createDayType = async () => {
    this.closeFormModal();
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      state: this.state,
      userId: this.props.user.login.id,
      updateState: this.updateState,
      addResourceDayType: this.props.actions.addResourceDayType,
      Toast,
      refreshPage: this.refreshPage
    };
    await CRUD.createDayType(parameters);
    // const { itemDetails } = this.state;
    // const dayType = await this.generateNewOptimisticItem('addDayType', itemDetails);
    // const resourceId = this.state.resource.id;
    // await this.props.actions.addDayTypeOptimistic(itemDetails, dayType, resourceId);
    // this.refreshOptimisticLiveSchedule();
    this.props.closeLiveScheduleUpdate(this.state)
  }

  updateDayType = async () => {
    this.closeFormModal();
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      state: this.state,
      userId: this.props.user.login.id,
      updateState: this.updateState,
      editResourceDayType: this.props.actions.editResourceDayType,
      Toast,
      refreshPage: this.refreshPage
    };
    await CRUD.updateDayType(parameters);
    // const { itemDetails } = this.state;
    // const updatedResource = await this.generateNewOptimisticItem('editDayType', itemDetails);
    // await this.props.actions.editDayTypeOptimistic(itemDetails, updatedResource);
    // this.refreshOptimisticLiveSchedule();
    this.props.closeLiveScheduleUpdate(this.state)
  }

  deleteDayType = async () => {
    this.closeFormModal();
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      state: this.state,
      userId: this.props.user.login.id,
      updateState: this.updateState,
      removeResourceDayTypes: this.props.actions.removeResourceDayTypes,
      Toast,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteDayType(parameters);
    // const { itemDetails } = this.state;
    // await this.props.actions.deleteDayTypeOptimistic(itemDetails);
    // this.refreshOptimisticLiveSchedule();
    this.props.closeLiveScheduleUpdate(this.state);
  }

  createTourPreReq = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    const resourceId = this.state.resource.id;
    const { itemDetails } = this.state;
    const { dayTypeId, tourStartTime } = itemDetails;
    const date = tourStartTime.format('YYYYMMDD');
    const userId = this.props.user.login.id;
    // get prerequisite data to create a tour
    await this.props.actions.fetchCreateTourPreReq(dayTypeId, resourceId, date, userId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading createTourPreReq failed\n" + JSON.stringify(error));
        }
      });
    const parameters = {
      state: this.state,
      userId,
      createTourPreReq: this.props.createTourPreReq,
      updateState: this.updateState,
      addResourceDayType: this.props.actions.addResourceDayType,
      editResourceDayType: this.props.actions.editResourceDayType,
      Toast
    };
    return await CRUD.createTourPreReq(parameters);
  }

  createTour = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    const { itemDetails } = this.state;
    if (itemDetails.mealStartTime) {
      this.setState({
        crudLoading: true
      }, () => {
        // or else this component will un-mount before createMeal gets to fire
        this.closeFormModal();
      });
    } else if (!itemDetails.mealStartTime) {
      this.closeFormModal();
    }
    // invoke local createTourPreReq method above
    const createTourPreReq = await this.createTourPreReq().catch(error => {
      alert('Something went wrong with the createTourPreReq function' + JSON.stringify(error));
      console.log(error);
    });
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      createTourPreReq,
      state: this.state,
      userId: this.props.user.login.id,
      updateState: this.updateState,
      addTour: this.props.actions.addTour,
      Toast,
      refreshPage: this.refreshPage,
      contextMenuSelection: this.props.contextMenuSelection
    };
    await CRUD.createTour(parameters);
    // update state w/ newly created tour
    let tour = await this.props.tour;
    itemDetails.tourId = tour.tourId;
    this.setState({itemDetails});

    // optimistic rendering
    if (this.props.contextMenuSelection === 'Add Tour') {
      // const dayType = await this.generateNewOptimisticItem('addTour', itemDetails);
      // const resourceId = this.state.resource.id;
      // await this.props.actions.addTourOptimistic(itemDetails, dayType, resourceId);

      // if tour was created, create meal (when applicable)
      if (itemDetails.mealStartTime) {
        this.createMeal();
      }
      // this.refreshOptimisticLiveSchedule();
      this.props.closeLiveScheduleUpdate(this.state);
    }
  }

  createMeal = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    const parameters = {
      tour: this.props.tour,
      state: this.state,
      contextMenuSelection: this.props.contextMenuSelection,
      userId: this.props.user.login.id,
      addMeal: this.props.actions.addMeal,
      Toast,
      updateState: this.updateState,
    };
    await CRUD.createMeal(parameters);
    this.props.closeLiveScheduleUpdate(this.state);
  }

  updateTour = async () => {
    this.closeFormModal();
    const resourceId = this.state.resource.id;
    await this.props.actions.fetchResourcePersonnelData(resourceId).catch(error => {
      alert("Loading resourcePersonnelData failed\n" + JSON.stringify(error));
      console.log(error);
    });
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      resourcePersonnelData: this.props.resourcePersonnelData.data[0],
      state: this.state,
      userId: this.props.user.login.id,
      updateState: this.updateState,
      editTour: this.props.actions.editTour,
      Toast,
      refreshPage: this.refreshPage
    };
    await CRUD.updateTour(parameters);
    if (this.contextMenuSelection === 'Edit Tour') {
      this.props.closeLiveScheduleUpdate(this.state)
    }


    // optimistic rendering
    // const { itemDetails } = this.state;
    // if (this.props.contextMenuSelection === 'Edit Tour') { // don't generate optimistic render if this originated from creating/editing assignment
    //   const updatedResource = await this.generateNewOptimisticItem('editTour', itemDetails);
    //   await this.props.actions.editTourOptimistic(itemDetails, updatedResource);
    //   this.refreshOptimisticLiveSchedule();
    // }
  }

  deleteTour = async () => {
    this.closeFormModal();
    const parameters = {
      state: this.state,
      tourId: this.props.itemDetails.id,
      userId: this.props.user.login.id,
      removeTour: this.props.actions.removeTour,
      Toast,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteTour(parameters);
    // const { itemDetails } = this.state;
    // TODO: must re-write optimistic render to convert all assignments within to standby
    // await this.props.actions.deleteTourOptimistic(itemDetails);
    // this.refreshOptimisticLiveSchedule();
    this.props.closeLiveScheduleUpdate() // unmount this component - prevent redundant dialogue boxes popping up
  }

  updateMeal = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      editMeal: this.props.actions.editMeal,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.updateMeal(parameters);
    this.props.closeLiveScheduleUpdate(this.state);
  }

  deleteMeal = async () => {
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      removeMeal: this.props.actions.removeMeal,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteMeal(parameters);
    this.props.closeLiveScheduleUpdate()
  }

  // pay transactions

  getTourPayTransaction = async (tourPayTransactionId) => {
    await this.props.actions.fetchTourPayTransaction(tourPayTransactionId).catch(error => {
      alert("Loading tourPayTransaction failed\n" + JSON.stringify(error));
      console.log(error);
    });
    this.setState({
      tourPayTransaction: this.props.tourPayTransaction
    });
  }

  createTourPayTransaction = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      addTourPayTransaction: this.props.actions.addTourPayTransaction,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.createTourPayTransaction(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  updateTourPayTransaction = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      editTourPayTransaction: this.props.actions.editTourPayTransaction,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.updateTourPayTransaction(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  deleteTourPayTransaction = async () => {
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      removeTourPayTransaction: this.props.actions.removeTourPayTransaction,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteTourPayTransaction(parameters);
    this.props.closeLiveScheduleUpdate()
  }

  // indicators

  getTourIndicator = async (tourIndicatorId) => {
    await this.props.actions.fetchTourIndicator(tourIndicatorId).catch(error => {
      alert("Loading tourIndicator failed\n" + JSON.stringify(error));
      console.log(error);
    });
    this.setState({
      tourIndicator: this.props.tourIndicator
    });
  }

  getCodesByIndicator = async () => {
    const { indicatorId } = this.state.itemDetails;
    await this.props.actions.fetchCodesByIndicator(indicatorId).catch(error => {
      alert("Loading codesByIndicator failed\n" + JSON.stringify(error));
      console.log(error);
    });
    this.setState({
      codesByIndicator: this.props.codesByIndicator
    });
  }

  createTourIndicator = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      addTourIndicator: this.props.actions.addTourIndicator,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.createTourIndicator(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  updateTourIndicator = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      editTourIndicator: this.props.actions.editTourIndicator,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.updateTourIndicator(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  deleteTourIndicator = async () => {
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      removeTourIndicator: this.props.actions.removeTourIndicator,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteTourIndicator(parameters);
    this.props.closeLiveScheduleUpdate()
  }

  // activity flags

  getTourActivityFlag = async (tourActivityFlagId) => {
    await this.props.actions.fetchTourActivityFlag(tourActivityFlagId).catch(error => {
      alert("Loading tourActivityFlag failed\n" + JSON.stringify(error));
      console.log(error);
    });
    this.setState({
      tourActivityFlag: this.props.tourActivityFlag
    });
  }

  createTourActivityFlag = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      addTourActivityFlag: this.props.actions.addTourActivityFlag,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.createTourActivityFlag(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  updateTourActivityFlag = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      editTourActivityFlag: this.props.actions.editTourActivityFlag,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.updateTourActivityFlag(parameters);
    this.props.closeLiveScheduleUpdate();
  }

  deleteTourActivityFlag = async () => {
    this.closeFormModal();
    const parameters = {
      state: this.state,
      userId: this.props.user.login.id,
      removeTourActivityFlag: this.props.actions.removeTourActivityFlag,
      updateState: this.updateState,
      refreshPage: this.refreshPage
    };
    await CRUD.deleteTourActivityFlag(parameters);
    this.props.closeLiveScheduleUpdate()
  }

  // *** END EDIT TOUR TABS ***

  handleCostObjectFilterChange = (action, record) => {
    const { itemDetails } = this.state;
    if (action === 'update') {
      record.costObjectTypeId = record.costObjectType === 'COST_CENTER' ? 2 : 1; // TODO: fix findCostObject so PROJECT_DEFINITION isn't possible
      itemDetails.costObjectFilter = record;
    } else if (action === 'delete') {
      if (itemDetails.costObjectFilter) {
        delete itemDetails.costObjectFilter;
      }
    }
    this.setState({
      itemDetails
    });
  }

  getRelevantJobs = async () => {
    const userId = this.props.user.login.id;
    const { assignmentStartTime } = this.state.itemDetails;
    const referenceDate = moment(assignmentStartTime).format();
    await this.props.actions.fetchRelevantJobs(referenceDate, userId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getRelevantJobs failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      relevantJobs: this.props.relevantJobs.data
    });
  }

  // trigger filter jobs (requests) by cost object filter (add assignment)
  getRelevantJobsForCostObject = async () => {
    const userId = this.props.user.login.id;
    const { assignmentStartTime } = this.state.itemDetails;
    const referenceDate = moment(assignmentStartTime).format();
    const { costObjectFilter } = this.state.itemDetails;
    const costObjectId = costObjectFilter.id;
    const { costObjectTypeId } = costObjectFilter;
    await this.props.actions.fetchRelevantJobsForCostObject(referenceDate, userId, costObjectId, costObjectTypeId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getRelevantJobsForCostObject failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      relevantJobsForCostObject: this.props.relevantJobsForCostObject.data
    });
  }

  // trigger groups dropdown (add assignment)
  getGroupsByBranchAndResource = async () => {
    const { executingBranchId } = this.state.itemDetails;
    const { resource } = this.state;
    if (executingBranchId && executingBranchId !== 'null') {
      await this.props.actions.fetchGroupsByBranchAndResource(executingBranchId, resource.id)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getGroupsByBranchAndResource failed\n" + JSON.stringify(error));
          }
        });
      this.setState({
        groupsByBranchAndResource: this.props.groupsByBranchAndResource.data
      });
    }
  }

  // trigger services dropdown (add assignment)
  getServicesByDate = async () => {
    const { resource } = this.state;
    const { itemDetails } = this.state;
    const { executingBranchId, assignmentStartTime, assignmentEndTime, groupId, priceMethodId } = itemDetails;
    const startTime = moment(assignmentStartTime).format();
    const endTime = moment(assignmentEndTime).format();
    const { timeZoneId } = await this.props.relatedBranches.data.find((elem) => elem.id == itemDetails.executingBranchId);
    // grab relevant timeZoneId from relatedBranches array in props since executing branch has already been selected
    if (executingBranchId && executingBranchId !== 'null' && startTime && endTime && groupId && groupId !== 'null' && timeZoneId) {
      await this.props.actions.fetchServicesByDate(executingBranchId, resource.id, startTime, endTime, priceMethodId, groupId, timeZoneId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getServicesByDate failed\n" + JSON.stringify(error));
          }
        });
      // update state w/ current timeZoneId from relatedBranches dropdown selection
      itemDetails.timeZoneId = timeZoneId;
      this.setState({
        servicesByDate: this.props.servicesByDate.data,
        itemDetails
      });
    }
  }

  // trigger activity types dropdown (add/edit assignment)
  getActivityTypes = async () => {
    const { contextMenuSelection } = this.props;
    const { itemDetails } = this.state;
    let relatedServiceId;
    let referenceDate;
    if (contextMenuSelection === 'Add Assignment') {
      relatedServiceId = itemDetails.relatedServiceId;
      let { assignmentStartTime } = itemDetails;
      referenceDate = moment(assignmentStartTime).format();
    } else if (contextMenuSelection === 'Edit Assignment') {
      relatedServiceId = itemDetails.selectedJobElementDetails.relatedServiceId;
      referenceDate = itemDetails.selectedJobElementDetails.startActual;
    }

    if (relatedServiceId && referenceDate) {
      await this.props.actions.fetchActivityTypes(relatedServiceId, referenceDate)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getActivityTypes failed\n" + JSON.stringify(error));
          }
        });
      this.setState({
        activityTypes: await this.props.activityTypes.data
      });
    }
  }

  // trigger service salary level api (add/edit assignment)
  getServiceSalaryLevel = async () => {
    const { contextMenuSelection } = this.props;
    const { itemDetails } = this.state;
    let serviceId;
    if (contextMenuSelection === 'Add Assignment') {
      serviceId = itemDetails.serviceId;
    } else if (contextMenuSelection === 'Edit Assignment') {
      serviceId = itemDetails.selectedJobElementDetails.serviceId;
    }
    if (serviceId) {
      await this.props.actions.fetchServiceSalaryLevel(serviceId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getServiceSalaryLevel failed\n" + JSON.stringify(error));
          }
        });
      this.setState({
        serviceSalaryLevel: this.props.serviceSalaryLevel.name
      });
    }
  }

  // trigger service primary rate api (add/edit assignment)
  getServicePrimaryRate = async () => {
    const { contextMenuSelection } = this.props;
    const { itemDetails } = this.state;
    let serviceId;
    if (contextMenuSelection === 'Add Assignment') {
      serviceId = itemDetails.serviceId;
    } else if (contextMenuSelection === 'Edit Assignment') {
      serviceId = itemDetails.selectedJobElementDetails.serviceId;
    }
    if (serviceId) {
      await this.props.actions.fetchServicePrimaryRate(serviceId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getServicePrimaryRate failed\n" + JSON.stringify(error));
          }
        });
      this.setState({
        servicePrimaryRate: this.props.servicePrimaryRate.primaryRate
      });
    }
  }

  // trigger jobSalaryUpgradeId dropdown (add/edit assignment)
  getJobSalariesByService = async () => {
    const { contextMenuSelection } = this.props;
    const { itemDetails } = this.state;
    let serviceId;
    let startTime;
    if (contextMenuSelection === 'Add Assignment') {
      serviceId = itemDetails.serviceId;
      startTime = itemDetails.assignmentStartTime.format();
    } else if (contextMenuSelection === 'Edit Assignment') {
      serviceId = itemDetails.selectedJobElementDetails.serviceId;
      startTime = itemDetails.selectedJobElementDetails.startActual;
    }

    if (serviceId && startTime) {
      await this.props.actions.fetchJobSalariesByService(serviceId, startTime)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getJobSalariesByService failed\n" + JSON.stringify(error));
          }
        });
      let serviceJobSalaries = _.map(this.props.serviceJobSalaries.data, _.clone);
      this.setState({
        serviceJobSalaries: serviceJobSalaries.sort((a, b) => (a.name > b.name) ? -1 : 1)
      });
    }
  }

  // (add assignment)
  getActiveTours = async () => {
    const { resource } = this.state;
    const { itemDetails } = this.state;
    const { assignmentStartTime, timeZoneId } = itemDetails;
    await this.props.actions.fetchActiveTours(resource.id, assignmentStartTime, timeZoneId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getActiveTours failed\n" + JSON.stringify(error));
        }
      });
  }

  // (add assignment)
  getDefaultTourLength = async () => {
    const { resource, itemDetails } = this.state;
    const { relatedServiceId, assignmentStartTime, serviceId } = itemDetails;
    const startTime = assignmentStartTime.format();
    await this.props.actions.fetchDefaultTourLength(relatedServiceId, startTime, parseInt(resource.id), serviceId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getDefaultTourLength failed\n" + JSON.stringify(error));
        }
      });
  }

  createAssignment = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.setState({
      crudLoading: true
    }, () => {
      this.closeFormModal();
    });
    const { resource, itemDetails } = this.state;
    const { assignmentStartTime, assignmentEndTime, jobTitle } = itemDetails;
    let { jobId } = itemDetails;

    const day = moment(assignmentStartTime).format('M/D/YYYY (ddd)');
    let logControlId;

    let userId = this.props.user.login.id;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;
    let addJob = this.props.actions.addJob;
    let addJobElement = this.props.actions.addJobElement;
    itemDetails.logControlIds = {};

    // create job
    if (!jobId || jobId === 'null') {
      // no pre-existing jobId
      await CRUD.createAssignment.logStart({userId, resource, day, logJobStart});
      logControlId = await this.props.logJobStartRecord.logControlId;
      itemDetails.logControlIds.job = logControlId;
      await CRUD.createAssignment.createJob({resource, logControlId, userId, itemDetails,
        addJob, day, state: this.state, updateState: this.updateState});
      let jobId = this.props.job.jobId;
      itemDetails.jobId = jobId;
      await CRUD.createAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});
      // update state
      this.setState({itemDetails});
    }

    if (itemDetails.status === 10) {
      // standby assignment (no associated tour)
      // create jobElement
      await CRUD.createAssignment.logStart({userId, resource, day, logJobStart});
      logControlId = await this.props.logJobStartRecord.logControlId;
      itemDetails.logControlIds.jobElement = logControlId;
      await CRUD.createAssignment.createJobElement({resource, logControlId, userId, itemDetails,
        addJobElement, day, state: this.state, updateState: this.updateState, refreshPage: this.refreshPage});
      let { jobId } = itemDetails;
      await CRUD.createAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});
      // update state
      this.setState({itemDetails});
    } else {
      // assignment is part of a tour (concurrent / placed / completed )
      // validate that tour exists
      await this.getActiveTours();
      let activeTours = await this.props.activeTours;
      if (activeTours.counter > 0) {
        // tour on the same day exists
        if (activeTours.data[0].reconciled) {
          // tour is reconciled (approved) so cannot add assignments to it
          // change assignment status to standby
          itemDetails.status = 10;
        } else {
          // tour is not reconciled, ok to add assignment to it

          // format start/end time for tour changes
          let tourStartTime = activeTours.data[0].dateTimeStartActual.split('T')[0] + " " + (activeTours.data[0].dateTimeStartActual.split('T')[1]).split('.000Z')[0];
          let tourEndTime = activeTours.data[0].dateTimeEndActual.split('T')[0]  + " " +  (activeTours.data[0].dateTimeEndActual.split('T')[1]).split('.000Z')[0];

          tourStartTime = moment(tourStartTime, 'YYYY-MM-DD HH:mm:ss');
          tourEndTime = moment(tourEndTime, 'YYYY-MM-DD HH:mm:ss');

          if (moment(assignmentStartTime).isBefore(tourStartTime) || moment(assignmentEndTime).isAfter(tourEndTime)) {
            // assignment isn't (completely) inside existing tour
            let startDate = moment(tourStartTime).startOf('day').format('YYYY-MM-DD HH:mm:ss'); // getDetailedSchedules needs very beginning of startDate as input
            let endDate = moment(tourEndTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            await this.getDetailedSchedules(startDate, endDate, resource.id, userId);
            // update state w/ relevant tour for use in createJobElement api
            itemDetails.editTourForAssignment = true;
            itemDetails.tourId = activeTours.data[0].tourId;
            itemDetails.tourDetails = this.props.detailedSchedule.detailedSchedules[0];
            itemDetails.dayTypeId = dayTypes.find((elem) => elem.name == itemDetails.tourDetails.dayType).id;
            itemDetails.rdtId = itemDetails.tourDetails.rdtId;
            // adjust tour times
            if (moment(assignmentStartTime).isBefore(tourStartTime)) {
              itemDetails.tourStartTime = assignmentStartTime.clone();
              itemDetails.tourEndTime = tourEndTime;
            }
            if (moment(assignmentEndTime).isAfter(tourEndTime)) {
              itemDetails.tourEndTime = assignmentEndTime.clone();
              itemDetails.tourStartTime = tourStartTime;
            }
            this.setState({
              itemDetails,
              crudLoading: true // prevents page refresh after updateTour completes
            });
            await this.updateTour();
          }
        }
      } else if (activeTours.counter === 0){
        // no tour exists on the same calendar day as intended assignment
        // now createing a NEW TOUR
        await this.getDefaultTourLength();
        const defaultTourLength = await this.props.defaultTourLength.tourLength;
        const assignmentDuration = moment.duration(assignmentEndTime.diff(assignmentStartTime)).asMinutes();
        const tourDuration = defaultTourLength > assignmentDuration ? defaultTourLength : assignmentDuration;
        // populate state w/ fields for new tour
        itemDetails.addTourForAssignment = true;
        itemDetails.tourDuration = tourDuration;
        itemDetails.tourStartTime = assignmentStartTime.clone();
        itemDetails.tourEndTime = assignmentStartTime.clone();
        itemDetails.tourEndTime = itemDetails.tourEndTime.add(tourDuration, 'minutes');
        itemDetails.mealStartTime = assignmentStartTime.clone();
        itemDetails.mealEndTime = assignmentStartTime.clone();
        itemDetails.mealStartTime = itemDetails.mealStartTime.add(4, 'hours');
        itemDetails.mealEndTime = itemDetails.mealEndTime.add(5, 'hours'); // TODO: resolve, meals can be longer/shorter than 1 hour
        itemDetails.dayTypeId = 25; // regular work day
        this.setState({
          itemDetails,
          crudLoading: true // prevents page refresh after createTour completes
        });
        // create tour
        await this.createTour();
        itemDetails.tourId = await this.props.tour.tourId;
        this.setState({itemDetails});
      }

      /**
       *  create jobElement
       *  only used for concurrent / placed / completed assignments (within existing tour)
       */
      await CRUD.createAssignment.logStart({userId, resource, day, logJobStart});
      logControlId = this.props.logJobStartRecord.logControlId;
      itemDetails.logControlIds.jobElement = logControlId;
      this.setState({
        itemDetails,
        crudLoading: false // clears up for page refresh after createJobElement completes
      });
      await CRUD.createAssignment.createJobElement({resource, logControlId, userId, itemDetails, addJobElement, day,
      state: this.state, updateState: this.updateState, refreshPage: this.refreshPage});
      let { jobId } = itemDetails;
      await CRUD.createAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});
    }

    // optimistic rendering
    // const obj = await this.generateNewOptimisticItem('addAssignment', itemDetails);
    // const resourceId = this.state.resource.id;
    // if (itemDetails.status === 10) {
    //   let dayType = obj;
    //   await this.props.actions.addDayTypeOptimistic(itemDetails, dayType, resourceId);
    // } else if (itemDetails.addTourForAssignment) {
    //   let dayType = obj;
    //   await this.props.actions.addTourOptimistic(itemDetails, dayType, resourceId);
    // } else if (itemDetails.editTourForAssignment) {
    //   let updatedResource = obj;
    //   await this.props.actions.editTourOptimistic(itemDetails, updatedResource);
    // }
    // this.refreshOptimisticLiveSchedule();
    this.props.closeLiveScheduleUpdate(this.state);
  }

  // (delete assignment)
  getValidateEmptyJob = async () => {
    const assignmentId = this.state.itemDetails.id;
    await this.props.actions.fetchValidateEmptyJob(assignmentId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getValidateEmptyJob failed\n" + JSON.stringify(error));
        }
      });
  }

  deleteAssignment = async () => {
    const { resource, itemDetails } = this.state;
    const { start_time, id, status } = itemDetails;
    const jobElementId = id;
    const day = moment(start_time).format('M/D/YYYY (ddd)');
    let logControlId;

    let userId = this.props.user.login.id;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;
    let removeJobElement = this.props.actions.removeJobElement;
    itemDetails.logControlIds = {};

    await this.getValidateEmptyJob();
    let soleJobElementInJob;
    if (this.props.validateEmptyJob.jobId) {
      // this job will be empty after deleting this job element
      soleJobElementInJob = true;
      // pause all refreshes and un-mounting while user reads 'empty job' pop-up
      this.setState({
        deleteEmptyJobLoading: true
      });
      const { message } = this.props.validateEmptyJob;
      let text = {
        title: `Delete Assignment`,
        content: `The following request will be empty after deleting the selected assignment. ${message} Do you want to delete the empty request?`
      };
      // await Confirm('deleteEmptyJob', text, this.handleConfirmDialogue);
      window.confirm(text.content);
      this.setState({
        deleteEmptyJobLoading: false
      });
    } else {
      // this job will still have job elements after this job element is deleted
      soleJobElementInJob = false;
      this.setState({
        deleteEmptyJobLoading: false
      });
    }

    // update state w/ current control flow
    itemDetails.soleJobElementInJob = soleJobElementInJob;
    this.setState({
      itemDetails
    });

    // delete job element
    await CRUD.deleteAssignment.logStart({userId, resource, day, logJobStart});
    logControlId = await this.props.logJobStartRecord.logControlId;
    itemDetails.logControlIds.jobElement = logControlId;
    await CRUD.deleteAssignment.removeJobElement({resource, logControlId, userId, jobElementId, removeJobElement, day,
    updateState: this.updateState, refreshPage: this.refreshPage });
    let { jobId } = itemDetails;
    await CRUD.deleteAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});
    this.setState({
      itemDetails,
      deleteJobElementLoading: false
    });

    // optimistic rendering
    // if (status === '10') {
    //   // standby assignment, delete the dayType to delete the assignment
    //   // will remove assignment bc assignment-dayTypes have rdtId = assignment jeId
    //   await this.props.actions.deleteDayTypeOptimistic(itemDetails);
    //   this.refreshOptimisticLiveSchedule();
    // } else { // assignment within a tour
    //   const updatedResource = await this.generateNewOptimisticItem('deleteAssignment', itemDetails);
    //   await this.props.actions.editTourOptimistic(itemDetails, updatedResource);
    //   this.refreshOptimisticLiveSchedule()
    // }

    // only un-mount if delete empty job is done or didn't run
    if (!this.state.deleteEmptyJobLoading) {
      this.props.closeLiveScheduleUpdate(this.state);
    }

  }

  // Delete Empty Job confirmation click
  componentDidUpdate() {
    const { itemDetails, confirmDialogue, deletingEmptyJob } = this.state;
    if (!deletingEmptyJob) {
      if (itemDetails.soleJobElementInJob && confirmDialogue.deleteEmptyJob) {
        this.setState({
          deletingEmptyJob: true,
        }, () => {
          // delete (now empty) job
          this.deleteEmptyJob();
        });
      }
    }
  }

  deleteEmptyJob = async () => {
    const { resource, itemDetails } = this.state;
    const { start_time, id } = itemDetails;
    const jobElementId = id;
    const day = moment(start_time).format('M/D/YYYY (ddd)');
    let logControlId;

    let userId = this.props.user.login.id;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;
    let removeJob = this.props.actions.removeJob;
    itemDetails.logControlIds = {};

    await CRUD.deleteAssignment.logStart({userId, resource, day, logJobStart});
    logControlId = this.props.logJobStartRecord.logControlId;
    itemDetails.logControlIds.job = logControlId;
    this.setState({itemDetails});
    let { jobId } = itemDetails;
    await CRUD.deleteAssignment.removeJob({resource, logControlId, userId, jobId, removeJob, day,
      updateState: this.updateState, refreshPage: this.refreshPage});
    await CRUD.deleteAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});

    // no need for optimistic rendering
    // only un-mount if delete jobElement is done
    // if (!this.state.deleteJobElementLoading) {
      this.props.closeLiveScheduleUpdate(this.state);
    // }
  }

  // load selected assignment (edit assignment)
  getJobElement = async (jobElementId) => {
    await this.props.actions.fetchJobElement(jobElementId) // don't need await here, hurts perf
    .catch(error => {
      if (!_.isEmpty(error)) {
        alert("Loading getJobElementId failed\n" + JSON.stringify(error));
      }
    });
    this.setState({
      jobElement: await this.props.jobElement.data[0]
    });
  }

  // trigger group dropdown (edit assignment)
  getGroupsByBranchInCompany = async () => {
    const { executingBranchId } = this.state.itemDetails.selectedJobElementDetails;
    await this.props.actions.fetchGroupsByBranchInCompany(executingBranchId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getGroupsByBranchInCompany failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      groupsByBranchInCompany: await this.props.groupsByBranchInCompany.data,
    });
  }


  // get service info for selected jobElement (edit assignment)
  getService = async () => {
    const { serviceId } = this.state.itemDetails.selectedJobElementDetails;
    await this.props.actions.fetchService(serviceId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getService failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      service: await this.props.service.data[0]
    });
  }

  // trigger service dropdown (only on initial form load) (edit assignment)
  getAssignmentServicesByGroup = async () => {
    const { itemDetails } = this.state;
    const { serviceId } = itemDetails.selectedJobElementDetails;
    const groupId = await this.props.service.data[0].groupId
    await this.props.actions.fetchAssignmentServicesByGroup(groupId, serviceId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getAssignmentServicesByGroup failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      assignmentServicesByGroup: await this.props.assignmentServicesByGroup.data,
    });
  }

    // update service - but only when groupId changes from dropdown menu (edit assignment)
    getServicesByGroup = async () => {
      const { itemDetails } = this.state;
      const { serviceId } = itemDetails.selectedJobElementDetails;
      const { groupId } = itemDetails; // new groupId from group dropdown menu
      await this.props.actions.fetchServicesByGroup(groupId, serviceId)
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Loading getServicesByGroup failed\n" + JSON.stringify(error));
          }
        });
      this.setState({
        servicesByGroup: await this.props.servicesByGroup.data
      });
    }

  updateAssignment = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.setState({
      crudLoading: true
    }, () => {
      this.closeFormModal();
    });
    const userId = this.props.user.login.id;
    const { resource, itemDetails } = this.state;
    const { resourceId, resourceName, jobId, assignmentStartTime, assignmentEndTime,
      status } = itemDetails; // resoruceId comes from form, not necessarily original resource assigned

    const day = moment(assignmentStartTime).format('M/D/YYYY (ddd)');
    let logControlId;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;

    /**
     * if standby job element has been converted to concurrent, placed or completed
     * then initiate process to the create the tour that will house the updated
     * job element (very similar to code in this.createAssignment method)
     */
    if (itemDetails.selectedJobElementDetails.status === 10 && itemDetails.status !== 10) {
      // updated assignment is now part of a tour
      // see if a tour exists on that day already
      await this.getActiveTours();
      let activeTours = this.props.activeTours;
      if (activeTours.counter > 0) {
        // tour on the same day exists
        if (activeTours.data[0].reconciled) {
          // tour is reconciled (approved) so cannot add assignments to it
          // change assignment status back to standby
          itemDetails.status = 10;
        } else {
          // tour is not reconciled, ok to add assignment to it

          // format start/end time for tour changes
          let tourStartTime = activeTours.data[0].dateTimeStartActual.split('T')[0] + " " + (activeTours.data[0].dateTimeStartActual.split('T')[1]).split('.000Z')[0];
          let tourEndTime = activeTours.data[0].dateTimeEndActual.split('T')[0]  + " " +  (activeTours.data[0].dateTimeEndActual.split('T')[1]).split('.000Z')[0];

          tourStartTime = moment(tourStartTime, 'YYYY-MM-DD HH:mm:ss');
          tourEndTime = moment(tourEndTime, 'YYYY-MM-DD HH:mm:ss');

          if (moment(assignmentStartTime).isBefore(tourStartTime) || moment(assignmentEndTime).isAfter(tourEndTime)) {
            // assignment isn't (completely) inside existing tour
            let startDate = moment(tourStartTime).startOf('day').format('YYYY-MM-DD HH:mm:ss'); // getDetailedSchedules needs very beginning of startDate as input
            let endDate = moment(tourEndTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            await this.getDetailedSchedules(startDate, endDate, resource.id, userId);
            // update state w/ relevant tour for use in createJobElement api
            itemDetails.editTourForAssignment = true;
            itemDetails.tourId = activeTours.data[0].tourId;
            itemDetails.tourDetails = this.props.detailedSchedule.detailedSchedules[0];
            itemDetails.dayTypeId = dayTypes.find((elem) => elem.name == itemDetails.tourDetails.dayType).id;
            itemDetails.rdtId = itemDetails.tourDetails.rdtId;
            // adjust tour times
            if (moment(assignmentStartTime).isBefore(tourStartTime)) {
              itemDetails.tourStartTime = assignmentStartTime.clone();
              itemDetails.tourEndTime = tourEndTime;
            }
            if (moment(assignmentEndTime).isAfter(tourEndTime)) {
              itemDetails.tourEndTime = assignmentEndTime.clone();
              itemDetails.tourStartTime = tourStartTime;
            }
            this.setState({
              itemDetails,
              crudLoading: true // prevents page refresh after updateTour completes
            });
            await this.updateTour();
          }
        }
      } else if (activeTours.counter === 0){
        // no tour exists on the same calendar day as intended assignment
        // now createing a new tour
        await this.getDefaultTourLength();
        const defaultTourLength = await this.props.defaultTourLength.tourLength;
        const assignmentDuration = moment.duration(assignmentEndTime.diff(assignmentStartTime)).asMinutes();
        const tourDuration = defaultTourLength > assignmentDuration ? defaultTourLength : assignmentDuration;
        // populate state w/ fields for new tour
        itemDetails.addTourForAssignment = true;
        itemDetails.tourDuration = tourDuration;
        itemDetails.tourStartTime = assignmentStartTime.clone();
        itemDetails.tourEndTime = assignmentStartTime.clone();
        itemDetails.tourEndTime = itemDetails.tourEndTime.add(tourDuration, 'minutes');
        itemDetails.mealStartTime = assignmentStartTime.clone();
        itemDetails.mealEndTime = assignmentStartTime.clone();
        itemDetails.mealStartTime = itemDetails.mealStartTime.add(4, 'hours');
        itemDetails.mealEndTime = itemDetails.mealEndTime.add(5, 'hours'); // TODO: resolve, meals can be longer/shorter than 1 hour
        itemDetails.dayTypeId = 25; // regular work day
        this.setState({
          itemDetails,
          crudLoading: true // prevents page refresh after createTour completes
        });
        // create tour
        await this.createTour();
        itemDetails.tourId = this.props.tour.tourId;
        this.setState({itemDetails});
      }

      // TODO: DELETE???
      // create jobElement
      // await CRUD.createAssignment.logStart({userId, resource, day, logJobStart});
      // logControlId = this.props.logJobStartRecord.logControlId;
      // itemDetails.logControlIds.jobElement = logControlId;
      // this.setState({itemDetails});
      // await CRUD.createAssignment.createJobElement({resource, logControlId, userId, itemDetails, addJobElement, day});
      // let { jobId } = itemDetails;
      // await CRUD.createAssignment.logFinish({resource, logControlId, jobId, day, logJobFinish});
    }

    await CRUD.updateAssignment.logStart({userId, resourceName, day, logJobStart});
    logControlId = this.props.logJobStartRecord.logControlId;
    itemDetails.logControlId = logControlId;
    this.setState({itemDetails});
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      state: this.state,
      userId,
      logControlId,
      updateState: this.updateState,
      editJobElement: this.props.actions.editJobElement,
      refreshPage: this.refreshPage
    };
    await CRUD.updateAssignment.updateJobElement(parameters);
    await CRUD.updateAssignment.logFinish({resourceName, logControlId, jobId, day, logJobFinish});
    this.props.closeLiveScheduleUpdate(this.state);
  }

  // check if job has approved jobElements (edit job)
  getApprovedJobElements = async () => {
    const jobId = this.state.job.id;
    await this.props.actions.fetchApprovedJobElements(jobId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getApprovedJobElements failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      approvedJobElements: await this.props.approvedJobElements
    });
  }

  // check which tours are linked to jobElements when deleting job w/ 'Delete Tours' checked (edit job)
  getJobElements = async () => {
    const jobId = this.state.job.id;
    await this.props.actions.fetchJobElements(jobId)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getJobElements failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      jobElements: await this.props.jobElements.data
    });
  }

  deleteJob = async () => {
    // delete tours linked to jobElements within the job
    const { deleteTours } = this.state.itemDetails;
    if (deleteTours) {
      let jobElementsInTours = [];
      for (let jobElement of this.props.jobElements.data) {
        if (jobElement.tourId !== 0) {
          jobElementsInTours.push(jobElement);
        }
      }

      // delete all the tours that house the job elements connected to this job
      for (let elem of jobElementsInTours) {
        const parameters = {
          state: this.state,
          tourId: elem.tourId,
          userId: this.props.user.login.id,
          removeTour: this.props.actions.removeTour,
          Toast,
          updateState: this.updateState
        };
        await CRUD.deleteJob.deleteTour(parameters);
      }
    }

    // delete the Job
    const { resource, itemDetails } = this.state;
    const { jobStartDate } = itemDetails;
    const day = moment(jobStartDate).format('M/D/YYYY (ddd)');
    let logControlId;
    let userId = this.props.user.login.id;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;
    let removeJob = this.props.actions.removeJob;
    itemDetails.logControlIds = {};

    await CRUD.deleteJob.logStart({userId, resource, day, logJobStart});
    logControlId = this.props.logJobStartRecord.logControlId;
    itemDetails.logControlIds.job = logControlId;
    this.setState({itemDetails});
    let { jobId } = itemDetails;
    await CRUD.deleteJob.removeJob({resource, logControlId, userId, jobId, removeJob, day,
    updateState: this.updateState, refreshPage: this.refreshPage});
    await CRUD.deleteJob.logFinish({resource, logControlId, jobId, day, logJobFinish});

    // no need for optimistic rendering on jobs, no visual rep. on timeline
    this.props.closeLiveScheduleUpdate();
  }

  updateJob = async () => {
    if (!this.finalFormValidation()) {
      return null;
    }
    this.setState({
      crudLoading: true
    }, () => {
      this.closeFormModal();
    });
    const userId = this.props.user.login.id;
    const { itemDetails, jobElements } = this.state;
    const { GTitle, jobId, jobStartDate } = itemDetails;

    const day = moment(jobStartDate).format('M/D/YYYY (ddd)');
    let logControlId;
    let logJobStart = this.props.actions.logJobStart;
    let logJobFinish = this.props.actions.logJobFinish;

    // update costObject for each jobElement if costObject was changed and that option was selected
    if (itemDetails.costObjectChange) {
      for (let jobElement of jobElements) {
        const { resourceId, startRequest } = jobElement;
        const day = moment(startRequest).format('M/D/YYY (ddd');
        await CRUD.updateJob.logStart({userId, resourceId, day, logJobStart});
        logControlId = this.props.logJobStartRecord.logControlId;
        itemDetails.logControlId = logControlId;
        this.setState({itemDetails}); // comment out for performance???
        const parameters = {
          finalFormValidation: this.finalFormValidation,
          jobElement,
          state: this.state,
          userId,
          logControlId,
          updateState: this.updateState,
          editJobElement: this.props.actions.editJobElement,
          refreshPage: this.refreshPage
        };
        await CRUD.updateJob.updateJobElement(parameters);
        await CRUD.updateJob.logFinish({resourceId, logControlId, jobId, day, logJobFinish});
      }
    }

    // update job
    await CRUD.updateJob.logStart({userId, GTitle, day, logJobStart});
    itemDetails.logControlIds = {};
    itemDetails.logControlIds.job = logControlId;
    logControlId = this.props.logJobStartRecord.logControlId;
    this.setState({itemDetails});
    const parameters = {
      finalFormValidation: this.finalFormValidation,
      state: this.state,
      userId,
      logControlId,
      updateState: this.updateState,
      editJob: this.props.actions.editJob,
      refreshPage: this.refreshPage
    };
    await CRUD.updateJob.updateJob(parameters);
    await CRUD.updateJob.logFinish({GTitle, logControlId, jobId, day, logJobFinish});

    // no need for optimistic rendering for jobs, no visual rep. on timeline
    this.props.closeLiveScheduleUpdate(this.state);
  }

  refreshPage = () => {
    if (
      !this.state.crudError
      && !this.state.crudLoading
      && !this.state.deleteJobElementLoading
      && !this.state.deleteEmptyJobLoading
      ) {
      setTimeout(() => {
        // give time for toaster notification to return
        window.location.reload();
      }, 1500);
    } else {
      console.log('Cannot refresh page due to crudError or other CRUD process');
    }
  }

  generateNewOptimisticItem = async (operation, itemDetails) => {
    const optimisticLiveSchedule = await this.props.optimisticLiveSchedule;
    const dayTypesAll = await this.props.dayTypesAll.dayTypes;
    const dayTypesAllowTour = dayTypes;
    const resourceId = this.state.resource.id;
    const newItem = generateNewOptimisticItem(operation, itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
    return newItem;
  }

  refreshOptimisticLiveSchedule = async () => {
    let newLiveSchedule = await this.props.optimisticLiveSchedule;
    await this.props.updateOptimisticLiveSchedule(newLiveSchedule);
    await this.props.actions.updateOptimisticReRenderStatus(true);
  }

  showModal = async () => {
    this.setState({
      showItemContextModal: true,
    });
  };

  closeFormModal = () => {
    // see LiveScheduleGroupContext component
    this.props.closeLiveScheduleUpdate(this.state);
    if (
      !this.state.crudError
      && !this.state.crudLoading
      && !this.state.deleteJobElementLoading
      && !this.state.deleteEmptyJobLoading
      ) {
        this.setState({
          showItemContextModal: false
        });
      }
  }

  handleModalCancel = () => {
    // see LiveScheduleView compoennt
    this.props.closeLiveScheduleUpdate(this.state); // unmount this component (from either parent/source)
    if (
      !this.state.crudError
      && !this.state.crudLoading
      && !this.state.deleteJobElementLoading
      && !this.state.deleteEmptyJobLoading
      ) {
        this.setState({
          showItemContextModal: false
        });
      }
  };

  render() {
    console.log(this.state); // debug
    console.log(`crudLoading: ${this.state.crudLoading}`); // debug
    console.log(`deleteEmptyJobLoading: ${this.state.deleteEmptyJobLoading}`); // debug
    console.log(`deleteJobElementLoading: ${this.state.deleteJobElementLoading}`); // debug

    const { showItemContextModal } = this.state;
    if (this.props.user && this.props.itemDetails) {
      if (this.props.contextMenuSelection === 'Add Tour') {
        const props = {
          state: this.state,
          contextMenuSelection: this.props.contextMenuSelection,
          handleModalCancel: this.handleModalCancel,
          user: this.props.user,
          handleTourDurationChange: this.handleTourDurationChange,
          handleTourStartTimeChange: this.handleTourStartTimeChange,
          handleTourEndTimeChange: this.handleTourEndTimeChange,
          handleMealStartTimeChange: this.handleMealStartTimeChange,
          handleMealEndTimeChange: this.handleMealEndTimeChange,
          handleOmnibusFieldChange: this.handleOmnibusFieldChange,
          createTour: this.createTour
        };
        return LiveScheduleUpdateFormContainer.AddTour(props);
      }
      if (this.props.contextMenuSelection === 'Add Assignment') {
        const props = {
          state: this.state,
          updateState: this.updateState,
          contextMenuSelection: this.props.contextMenuSelection,
          handleModalCancel: this.handleModalCancel,
          user: this.props.user,
          handleItemDurationChange: this.handleItemDurationChange,
          handleItemStartTimeChange: this.handleItemStartTimeChange,
          handleItemEndTimeChange: this.handleItemEndTimeChange,
          handleOmnibusFieldChange: this.handleOmnibusFieldChange,
          handleCostObjectFilterChange: this.handleCostObjectFilterChange,
          getRelevantJobs: this.getRelevantJobs,
          getRelevantJobsForCostObject: this.getRelevantJobsForCostObject,
          getGroupsByBranchAndResource: this.getGroupsByBranchAndResource,
          getServicesByDate: this.getServicesByDate,
          getActivityTypes: this.getActivityTypes,
          getServiceSalaryLevel: this.getServiceSalaryLevel,
          getServicePrimaryRate: this.getServicePrimaryRate,
          getJobSalariesByService: this.getJobSalariesByService,
          createAssignment: this.createAssignment
        };
        return LiveScheduleUpdateFormContainer.AddAssignment(props);
      }
      if (this.props.contextMenuSelection === 'Change Day Type') {
        const props = {
          state: this.state,
          contextMenuSelection: this.props.contextMenuSelection,
          handleModalCancel: this.handleModalCancel,
          user: this.props.user,
          handleDayTypeDateChange: this.handleDayTypeDateChange,
          handleOmnibusFieldChange: this.handleOmnibusFieldChange,
          updateDayType: this.updateDayType,
          createDayType: this.createDayType,
          handleItemDelete: this.handleItemDelete
        };
        return LiveScheduleUpdateFormContainer.ChangeDayType(props); // FormContainers
      }
      if (this.props.contextMenuSelection === 'Edit Tour') {
        const props = {
          // tour details
          state: this.state,
          user: this.props.user,
          contextMenuSelection: this.props.contextMenuSelection,
          handleModalCancel: this.handleModalCancel,
          handleTourDurationChange: this.handleTourDurationChange,
          handleTourStartTimeChange: this.handleTourStartTimeChange,
          handleTourEndTimeChange: this.handleTourEndTimeChange,
          handleMealStartTimeChange: this.handleMealStartTimeChange,
          handleOmnibusFieldChange: this.handleOmnibusFieldChange,
          updateTour: this.updateTour,
          handleItemDelete: this.handleItemDelete,
          // meals
          updateState: this.updateState,
          handleItemStartTimeChange: this.handleItemStartTimeChange,
          handleItemDurationChange: this.handleItemDurationChange,
          generateItemDuration: this.generateItemDuration,
          updateMeal: this.updateMeal,
          createMeal: this.createMeal,
          // pay transactions
          getTourPayTransaction: this.getTourPayTransaction,
          createTourPayTransaction: this.createTourPayTransaction,
          updateTourPayTransaction: this.updateTourPayTransaction,
          // indicators
          getTourIndicator: this.getTourIndicator,
          getCodesByIndicator: this.getCodesByIndicator,
          createTourIndicator: this.createTourIndicator,
          updateTourIndicator: this.updateTourIndicator,
          // activity flags
          getTourActivityFlag: this.getTourActivityFlag,
          createTourActivityFlag: this.createTourActivityFlag,
          updateTourActivityFlag: this.updateTourActivityFlag,

        };
        return LiveScheduleUpdateFormContainer.EditTour(props); // FormContainers
      }
      if (this.props.contextMenuSelection === 'Edit Assignment') {
        const props = {
          state: this.state,
          updateState: this.updateState,
          contextMenuSelection: this.props.contextMenuSelection,
          handleModalCancel: this.handleModalCancel,
          user: this.props.user,
          // edit job element
          generateItemDuration: this.generateItemDuration,
          handleItemDurationChange: this.handleItemDurationChange,
          handleItemStartTimeChange: this.handleItemStartTimeChange,
          handleItemEndTimeChange: this.handleItemEndTimeChange,
          handleOmnibusFieldChange: this.handleOmnibusFieldChange,
          handleCostObjectFilterChange: this.handleCostObjectFilterChange,
          getJobElement: this.getJobElement,
          getGroupsByBranchInCompany: this.getGroupsByBranchInCompany,
          getService: this.getService,
          getAssignmentServicesByGroup: this.getAssignmentServicesByGroup,
          getServicesByGroup: this.getServicesByGroup,
          getActivityTypes: this.getActivityTypes,
          getServiceSalaryLevel: this.getServiceSalaryLevel,
          getServicePrimaryRate: this.getServicePrimaryRate,
          getJobSalariesByService: this.getJobSalariesByService,
          updateAssignment: this.updateAssignment,
          // edit job
          getApprovedJobElements: this.getApprovedJobElements,
          getJobElements: this.getJobElements,
          handleItemDelete: this.handleItemDelete,
          updateJob: this.updateJob
        };
        return LiveScheduleUpdateFormContainer.EditAssignment(props); // FormContainers
      }
      if (this.props.contextMenuSelection === 'Add Day Off Request') { // <- James
        return (
          <Modal
            zIndex={2000}
            title={'Day Type Request'}
            visible={true}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[]}
          >
            <DayTypeRequestsUpdate
              readyApiCall={() => { window.location.reload() }}
              selectedDayTypeRequest={{ ...blankDayTypeRequest }}
              handleModalCancel={this.handleModalCancel}
              contextMenuKey={true}
              liveResource={this.state.resource}
            />
          </Modal>
        )
      }
      if (this.props.contextMenuSelection === 'Edit Days Off Request') {
        return (
          <Modal
            zIndex={2000}
            title={'Day Type Request'}
            visible={true}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[]}
          >
            <DayTypeRequestsUpdate
              readyApiCall={() => { window.location.reload() }}
              selectedDayTypeRequest={this.state.selectedDayTypeRequest}
              handleModalCancel={this.handleModalCancel}
              contextMenuKey={false}
              liveResource={this.state.resource}
              liveDayOffRequest={this.state.itemDetails}
              liveLoading={false}
            />
          </Modal>
        )
      }
      if (this.props.contextMenuSelection.slice(0, 6) === 'Delete') {
        return (
          null // confirm dialogue box will pop up (see handleItemDelete method)
        );
      }

    } else return <Spinner />

  }
}

LiveScheduleUpdate.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  liveSchedule: PropTypes.object,
  createTourPreReq: PropTypes.object,
  resourceDayType: PropTypes.object,
  tour: PropTypes.object,
  meal: PropTypes.object,
  dayTypesAll: PropTypes.object,
  optimisticReRender: PropTypes.boolean,
  optimisticLiveSchedule: PropTypes.array,
  detailedSchedule: PropTypes.object,
  resourcePersonnelData: PropTypes.object,
  relevantJobs: PropTypes.object,
  relevantJobsForCostObject: PropTypes.object,
  relatedBranches: PropTypes.object,
  groupsByBranchAndResource: PropTypes.object,
  servicesByDate: PropTypes.object,
  activityTypes: PropTypes.object,
  serviceSalaryLevel: PropTypes.object,
  servicePrimaryRate: PropTypes.object,
  serviceJobSalaries: PropTypes.object,
  logJobStartRecord: PropTypes.object,
  logJobFinishRecord: PropTypes.object,
  job: PropTypes.object,
  jobElement: PropTypes.object,
  activeTours: PropTypes.object,
  defaultTourLength: PropTypes.object,
  validateEmptyJob: PropTypes.object,
  costObject: PropTypes.object,
  jobElementsWithDetails: PropTypes.object,
  updatingUser: PropTypes.object,
  updateUserHistoryRecord: PropTypes.object,
  resourceByDates: PropTypes.object,
  groupsByBranchInCompany: PropTypes.object,
  service: PropTypes.object,
  assignmentServicesByGroup: PropTypes.object,
  servicesByGroup: PropTypes.object,
  approvedJobElements: PropTypes.object,
  jobElements: PropTypes.object,
  tourMeals: PropTypes.object,
  jobElementsByTour: PropTypes.object,
  tourPayTransactions: PropTypes.object,
  payTransactionsByTour: PropTypes.object,
  tourPayTransaction: PropTypes.object,
  tourIndicators: PropTypes.object,
  tourActivityFlags: PropTypes.object,
  indicatorsByTour: PropTypes.object,
  indicatorsById: PropTypes.object,
  codesByIndicator: PropTypes.object,
  tourIndicator: PropTypes.object,
  activityFlagByTour: PropTypes.object,
  tourActivityFlag: PropTypes.object,
  branch: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    liveSchedule: state.liveSchedules,
    createTourPreReq: state.createTourPreReq,
    resourceDayType: state.resourceDayType,
    tour: state.tour,
    meal: state.meal,
    dayTypesAll: state.dayTypesAll,
    optimisticReRender: state.liveScheduleOptimisticReRender.status,
    optimisticLiveSchedule: state.liveScheduleOptimisticSchedule.newLiveSchedule,
    detailedSchedule: state.detailedSchedules,
    resourcePersonnelData: state.resourcePersonnelData,
    relevantJobs: state.relevantJobs,
    relevantJobsForCostObject: state.relevantJobsForCostObject,
    relatedBranches: state.relatedBranches,
    groupsByBranchAndResource: state.groupsByBranchAndResource,
    servicesByDate: state.servicesByDate,
    activityTypes: state.activityTypes,
    serviceSalaryLevel: state.serviceSalaryLevel,
    servicePrimaryRate: state.servicePrimaryRate,
    serviceJobSalaries: state.serviceJobSalaries,
    logJobStartRecord: state.logJobStartRecord,
    logJobFinishRecord: state.logJobFinishRecord,
    job: state.job,
    jobElement: state.jobElement,
    activeTours: state.activeTours,
    defaultTourLength: state.defaultTourLength,
    validateEmptyJob: state.validateEmptyJob,
    costObject: state.costObject,
    jobElementsWithDetails: state.jobElementsWithDetails,
    updatingUser: state.updatingUser,
    updateUserHistoryRecord: state.updateUserHistoryRecord,
    resourceByDates: state.resourceByDates,
    groupsByBranchInCompany: state.groupsByBranchInCompany,
    service: state.service,
    assignmentServicesByGroup: state.assignmentServicesByGroup,
    servicesByGroup: state.servicesByGroup,
    approvedJobElements: state.approvedJobElements,
    jobElements: state.jobElements,
    tourMeals: state.tourMeals,
    jobElementsByTour: state.jobElementsByTour,
    tourPayTransactions: state.tourPayTransactions,
    payTransactionsByTour: state.payTransactionsByTour,
    tourPayTransaction: state.tourPayTransaction,
    tourIndicators: state.tourIndicators,
    tourActivityFlags: state.tourActivityFlags,
    indicatorsByTour: state.indicatorsByTour,
    indicatorsById: state.indicatorsById,
    codesByIndicator: state.codesByIndicator,
    tourIndicator: state.tourIndicator,
    activityFlagByTour: state.activityFlagByTour,
    tourActivityFlag: state.tourActivityFlag,
    branch: state.branch,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchCreateTourPreReq: bindActionCreators(
        tourActions.fetchCreateTourPreReq,
        dispatch
      ),
      addResourceDayType: bindActionCreators(
        dayTypeActions.addResourceDayType,
        dispatch
      ),
      editResourceDayType: bindActionCreators(
        dayTypeActions.editResourceDayType,
        dispatch
      ),
      addTour: bindActionCreators(
        tourActions.addTour,
        dispatch
      ),
      addMeal: bindActionCreators(
        mealActions.addMeal,
        dispatch
      ),
      removeTour: bindActionCreators(
        tourActions.removeTour,
        dispatch
      ),
      updateOptimisticReRenderStatus: bindActionCreators(
        liveScheduleActions.updateOptimisticReRenderStatus,
        dispatch
      ),
      updateOptimisticSchedule: bindActionCreators(
        liveScheduleActions.updateOptimisticSchedule,
        dispatch
      ),
      deleteTourOptimistic: bindActionCreators(
        liveScheduleActions.deleteTourOptimistic,
        dispatch
      ),
      addTourOptimistic: bindActionCreators(
        liveScheduleActions.addTourOptimistic,
        dispatch
      ),
      fetchResourceDayTypeByDate: bindActionCreators(
        dayTypeActions.fetchResourceDayTypeByDate,
        dispatch
      ),
      fetchResourceDayTypeById: bindActionCreators(
        dayTypeActions.fetchResourceDayTypeById,
        dispatch
      ),
      fetchDayTypesAll: bindActionCreators(
        dayTypeActions.fetchDayTypesAll,
        dispatch
      ),
      removeResourceDayTypes: bindActionCreators(
        dayTypeActions.removeResourceDayTypes,
        dispatch
      ),
      addDayTypeOptimistic: bindActionCreators(
        liveScheduleActions.addDayTypeOptimistic,
        dispatch
      ),
      deleteDayTypeOptimistic: bindActionCreators(
        liveScheduleActions.deleteDayTypeOptimistic,
        dispatch
      ),
      editDayTypeOptimistic: bindActionCreators(
        liveScheduleActions.editDayTypeOptimistic,
        dispatch
      ),
      fetchDetailedSchedules: bindActionCreators(
        detailedScheduleActions.fetchDetailedSchedules,
        dispatch
      ),
      fetchResourcePersonnelData: bindActionCreators(
        resourceActions.fetchResourcePersonnelData,
        dispatch
      ),
      editTour: bindActionCreators(
        tourActions.editTour,
        dispatch
      ),
      editTourOptimistic: bindActionCreators(
        liveScheduleActions.editTourOptimistic,
        dispatch
      ),
      fetchRelevantJobs: bindActionCreators(
        assignmentActions.fetchRelevantJobs,
        dispatch
      ),
      fetchRelevantJobsForCostObject: bindActionCreators(
        assignmentActions.fetchRelevantJobsForCostObject,
        dispatch
      ),
      fetchRelatedBranches: bindActionCreators(
        assignmentActions.fetchRelatedBranches,
        dispatch
      ),
      fetchGroupsByBranchAndResource: bindActionCreators(
        assignmentActions.fetchGroupsByBranchAndResource,
        dispatch
      ),
      fetchServicesByDate: bindActionCreators(
        assignmentActions.fetchServicesByDate,
        dispatch
      ),
      fetchActivityTypes: bindActionCreators(
        assignmentActions.fetchActivityTypes,
        dispatch
      ),
      fetchServiceSalaryLevel: bindActionCreators(
        assignmentActions.fetchServiceSalaryLevel,
        dispatch
      ),
      fetchServicePrimaryRate: bindActionCreators(
        assignmentActions.fetchServicePrimaryRate,
        dispatch
      ),
      fetchJobSalariesByService: bindActionCreators(
        assignmentActions.fetchJobSalariesByService,
        dispatch
      ),
      logJobStart: bindActionCreators(
        assignmentActions.logJobStart,
        dispatch
      ),
      logJobFinish: bindActionCreators(
        assignmentActions.logJobFinish,
        dispatch
      ),
      addJob: bindActionCreators(
        assignmentActions.addJob,
        dispatch
      ),
      addJobElement: bindActionCreators(
        assignmentActions.addJobElement,
        dispatch
      ),
      fetchActiveTours: bindActionCreators(
        tourActions.fetchActiveTours,
        dispatch
      ),
      fetchDefaultTourLength: bindActionCreators(
        tourActions.fetchDefaultTourLength,
        dispatch
      ),
      fetchValidateEmptyJob: bindActionCreators(
        assignmentActions.fetchValidateEmptyJob,
        dispatch
      ),
      removeJob: bindActionCreators(
        assignmentActions.removeJob,
        dispatch
      ),
      removeJobElement: bindActionCreators(
        assignmentActions.removeJobElement,
        dispatch
      ),
      fetchJob: bindActionCreators(
        assignmentActions.fetchJob,
        dispatch
      ),
      fetchJobElement: bindActionCreators(
        assignmentActions.fetchJobElement,
        dispatch
      ),
      fetchCostObject: bindActionCreators(
        assignmentActions.fetchCostObject,
        dispatch
      ),
      fetchJobElementsWithDetails: bindActionCreators(
        assignmentActions.fetchJobElementsWithDetails,
        dispatch
      ),
      fetchService: bindActionCreators(
        assignmentActions.fetchService,
        dispatch
      ),
      fetchGroupsByBranchInCompany: bindActionCreators(
        assignmentActions.fetchGroupsByBranchInCompany,
        dispatch
      ),
      fetchAssignmentServicesByGroup: bindActionCreators(
        assignmentActions.fetchAssignmentServicesByGroup,
        dispatch
      ),
      fetchServicesByGroup: bindActionCreators(
        assignmentActions.fetchServicesByGroup,
        dispatch
      ),
      fetchUpdatingUser: bindActionCreators(
        authActions.fetchUpdatingUser,
        dispatch
      ),
      updateUserHistory: bindActionCreators(
        authActions.updateUserHistory,
        dispatch
      ),
      fetchResourceByDates: bindActionCreators(
        resourceActions.fetchResourceByDates,
        dispatch
      ),
      editJobElement: bindActionCreators(
        assignmentActions.editJobElement,
        dispatch
      ),
      fetchApprovedJobElements: bindActionCreators(
        assignmentActions.fetchApprovedJobElements,
        dispatch
      ),
      fetchJobElements: bindActionCreators(
        assignmentActions.fetchJobElements,
        dispatch
      ),
      editJob: bindActionCreators(
        assignmentActions.editJob,
        dispatch
      ),
      fetchTourMeals: bindActionCreators(
        tourActions.fetchTourMeals,
        dispatch
      ),
      fetchJobElementsByTour: bindActionCreators(
        tourActions.fetchJobElementsByTour,
        dispatch
      ),
      fetchMeal: bindActionCreators(
        mealActions.fetchMeal,
        dispatch
      ),
      editMeal: bindActionCreators(
        mealActions.editMeal,
        dispatch
      ),
      removeMeal: bindActionCreators(
        mealActions.removeMeal,
        dispatch
      ),
      fetchPayTransactionsByTour: bindActionCreators(
        tourActions.fetchPayTransactionsByTour,
        dispatch
      ),
      fetchTourPayTransactions: bindActionCreators(
        tourActions.fetchTourPayTransactions,
        dispatch
      ),
      fetchTourPayTransaction: bindActionCreators(
        tourActions.fetchTourPayTransaction,
        dispatch
      ),
      addTourPayTransaction: bindActionCreators(
        tourActions.addTourPayTransaction,
        dispatch
      ),
      editTourPayTransaction: bindActionCreators(
        tourActions.editTourPayTransaction,
        dispatch
      ),
      removeTourPayTransaction: bindActionCreators(
        tourActions.removeTourPayTransaction,
        dispatch
      ),
      fetchTourIndicators: bindActionCreators(
        tourActions.fetchTourIndicators,
        dispatch
      ),
      fetchIndicatorsByTour: bindActionCreators(
        tourActions.fetchIndicatorsByTour,
        dispatch
      ),
      fetchIndicatorsById: bindActionCreators(
        tourActions.fetchIndicatorsById,
        dispatch
      ),
      fetchCodesByIndicator: bindActionCreators(
        tourActions.fetchCodesByIndicator,
        dispatch
      ),
      fetchTourIndicator: bindActionCreators(
        tourActions.fetchTourIndicator,
        dispatch
      ),
      addTourIndicator: bindActionCreators(
        tourActions.addTourIndicator,
        dispatch
      ),
      editTourIndicator: bindActionCreators(
        tourActions.editTourIndicator,
        dispatch
      ),
      removeTourIndicator: bindActionCreators(
        tourActions.removeTourIndicator,
        dispatch
      ),
      fetchTourActivityFlags: bindActionCreators(
        tourActions.fetchTourActivityFlags,
        dispatch
      ),
      fetchActivityFlagByTour: bindActionCreators(
        tourActions.fetchActivityFlagByTour,
        dispatch
      ),
      fetchTourActivityFlag: bindActionCreators(
        tourActions.fetchTourActivityFlag,
        dispatch
      ),
      addTourActivityFlag: bindActionCreators(
        tourActions.addTourActivityFlag,
        dispatch
      ),
      editTourActivityFlag: bindActionCreators(
        tourActions.editTourActivityFlag,
        dispatch
      ),
      removeTourActivityFlag: bindActionCreators(
        tourActions.removeTourActivityFlag,
        dispatch
      ),
      fetchBranch: bindActionCreators(
        userActions.fetchBranch,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveScheduleUpdate);






// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/LiveScheduleUpdate.js